import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2'
import store from '../../../store'
import router from '../../../router'
export default class VersionLogs{
  constructor() {
    this.detailsOfUpdate = [];
    this.latestVersion = '';
  }
  async getLogs(api, tokenHeader) {
    await axios.get(process.env.VUE_APP_DEPLOYMENT == 'TEST' ? `${api}versionlogstest` : `${api}versionlogs`, tokenHeader)
      .then(res => {
        this.detailsOfUpdate = res.data.filter(r => {
          r.ContentofRequest = r.ContentofRequest.replace(/(?:\r\n|\r|\n)/g, '<br>');
          r.DateRequested = moment(r.DateRequested).format('YYYY/MM/DD');
          return r;
        }).sort((a, b) => {
          return b.DateRequested - a.DateRequested || b.id - a.id;
        });
        if(this.detailsOfUpdate){
          this.latestVersion = this.detailsOfUpdate[0].Version
        }
      }).catch(err=>{
        console.log(err,'error2')
        if(err.response.status == 403 || err.response.status == 401){
          Swal.fire({
            icon: "info",
            title: `Token Expired System will forced logout`,
            showConfirmButton: true,
          }).then((result) => {
            if (result.isConfirmed) {
              store.commit("STORE_USERINFO", null);
              store.commit("STORE_SALESOFFICE", null)
              store.commit("STORE_CHART_URL", null);
              router.push("/login");
            }
          });
        }
      })
  }
}
